export type Problem = {
  emoji: string
  title: string
  text: string
}

export const problems: Problem[] = [
  {
    emoji: '📱',
    title: '"Mom, can I have your phone?"',
    text: 'It seems like the same request comes back all day long, turning simple moments into another screen-time battle.',
  },
  {
    emoji: '💸',
    title: 'Toys that lose their magic',
    text: 'You spend money on new toys, only to find them forgotten after a few days.',
  },
  {
    emoji: '😔',
    title: 'Too many hours on screens',
    text: 'You want her to spend less time staring at a screen — but finding something that truly keeps her interested isn\u2019t always easy.',
  },
  {
    emoji: '🧩',
    title: 'Play that doesn\u2019t last',
    text: 'Many activities capture her attention for a few minutes before ending up forgotten in a corner.',
  },
]

export type CollectionItem = {
  emoji: string
  title: string
  text: string
}

export const collection: CollectionItem[] = [
  {
    emoji: '✂️',
    title: 'Adorable Paper Dolls',
    text: 'Over 150 printable dolls in a variety of fun themes, ready for her to dress, decorate and bring into her own stories.',
  },
  {
    emoji: '👗',
    title: 'Dress-Up Outfits & Accessories',
    text: 'A huge selection of dresses, shoes, bows and accessories she can combine to create a different look every time.',
  },
  {
    emoji: '🏠',
    title: 'Buildable Dollhouses',
    text: 'Printable rooms and structures she can fold, assemble and turn into her very own little play spaces.',
  },
  {
    emoji: '🛋️',
    title: 'Rooms & Mini Furniture',
    text: 'Beds, sofas, wardrobes and interactive pieces that give her dolls a complete world to explore.',
  },
]

export type Step = {
  number: string
  title: string
  text: string
}

export const steps: Step[] = [
  {
    number: '1',
    title: 'Download your collection',
    text: 'Your complete kit is available immediately after completing your purchase.',
  },
  {
    number: '2',
    title: 'Print the pages',
    text: 'Use your regular home printer with standard paper or cardstock.',
  },
  {
    number: '3',
    title: 'Cut, create & play',
    text: 'Cut out the dolls and pieces, put everything together and let her imagination take over.',
  },
]

export type Bonus = {
  label: string
  value: string
  title: string
  text: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    label: 'FREE BONUS #1',
    value: 'Value $12',
    title: 'K-Pop Warriors World + Castles',
    text: 'A complete K-Pop-inspired adventure featuring warrior dolls and matching castles she can build, customize and use in her own stories.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/66fcf41e-b6cd-4138-adab-c6a7d071da3f.jpg',
  },
  {
    label: 'FREE BONUS #2',
    value: 'Value $14',
    title: 'Unicorn World + Mermaid World',
    text: 'Explore two magical settings in one collection — a whimsical unicorn world and an enchanting underwater mermaid kingdom.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/d91e576d-8fbe-4b00-8e74-6904fd024522.jpg',
  },
  {
    label: 'FREE BONUS #3',
    value: 'Value $10',
    title: 'Build-Your-Own Castles',
    text: 'Easy-to-assemble paper castles that transform her play area into a magical fairytale kingdom.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/63d724e1-319d-4d91-b7b5-d6a620de0acb.jpg',
  },
]

export type StackLine = {
  title: string
  price: string
}

export const valueStack: StackLine[] = [
  {
    title:
      '🎀 150+ Printable Paper Dolls Across 30 Magical Themes — Outfits, Accessories & Story Scenes',
    price: '$49',
  },
  { title: '🎁 Bonus #1: K-Pop Warriors World', price: '$12' },
  { title: '🎁 Bonus #2: Unicorn + Mermaid Worlds', price: '$14' },
  { title: '🎁 Bonus #3: Buildable Castles', price: '$10' },
]

export type Testimonial = {
  quote: string
  author: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'My daughter completely forgot about asking for my phone. She loves making different outfits and coming up with new stories for her dolls.',
    author: 'Sarah M.',
  },
  {
    quote:
      'We took it with us on a long road trip and it was such a lifesaver. She loved being able to mix and match everything from the different themes.',
    author: 'Camila R.',
  },
  {
    quote:
      'I originally bought it for my daughter, but she had so much fun with it that I ended up wishing I had bought it sooner. Definitely more exciting than another plastic toy.',
    author: 'Jennifer T.',
  },
]

export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'How will I receive my kit after purchasing?',
    answer:
      'You\u2019ll get immediate access to your files after checkout, so you can download everything right away without waiting for shipping.',
  },
  {
    question: 'Will I need a special printer?',
    answer:
      'Not at all. You can use any standard home printer and print the pages on regular paper or cardstock, depending on how sturdy you\u2019d like them to be.',
  },
  {
    question: 'What ages is the collection made for?',
    answer:
      'The activities and paper dolls are designed primarily for girls ages 4 to 10, although older children and collectors can enjoy creating with them too.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. My Magical World of Paper is a digital product. You\u2019ll receive the files digitally and can print the pages yourself at home whenever you want.',
  },
  {
    question: 'Can I print the files again?',
    answer:
      'Absolutely! Once purchased, the collection is yours to keep, so you can print the pages again whenever you need them — especially useful when a small piece gets lost or damaged.',
  },
  {
    question: 'What if it\u2019s not what I expected?',
    answer:
      'You\u2019re covered by a 30-day satisfaction guarantee. Just send us an email and we\u2019ll refund your purchase in full — and you keep all 3 bonuses.',
  },
]

export const galleryImages: string[] = [
  'https://cdn.magicpatterns.com/uploads/oGyHSM1GPfxeUKGWpGgqV6/Captura_de_pantalla_2026-08-10_215903.png',
  'https://cdn.magicpatterns.com/uploads/tgHrUsS1jTEm4hHTZ6PANj/Captura_de_pantalla_2026-08-10_215919.png',
  'https://cdn.magicpatterns.com/uploads/7SSbDMX1ArzTAK4icvy99j/Captura_de_pantalla_2026-08-11_000318.png',
  'https://cdn.magicpatterns.com/uploads/gw7E4y2DQr3XH1edghWxgQ/Captura_de_pantalla_2026-08-10_215958.png',
  'https://cdn.magicpatterns.com/uploads/piyDyqr9v1L8M5gxvVwzbw/Captura_de_pantalla_2026-08-10_235205.png',
  'https://cdn.magicpatterns.com/uploads/88J4EeJpcLL9wzTeYdU1uX/Captura_de_pantalla_2026-08-10_220014.png',
  'https://cdn.magicpatterns.com/uploads/thyG1n32cd1xeaZbdUnYTT/Captura_de_pantalla_2026-08-11_001305.png',
  'https://cdn.magicpatterns.com/uploads/wYwCP8k2kCZFakxmCk8JKe/Captura_de_pantalla_2026-08-10_220026.png',
  'https://cdn.magicpatterns.com/uploads/sGB8Y7Sd4n3cszJ4TMWBvn/Captura_de_pantalla_2026-08-10_235554.png',
]

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/8RbQCPBa32Cd3vjehBJEhW/ChatGPT_Image_11_ago_2026,_12_47_08_a.m..png'

export const mockupImage =
  'https://cdn.magicpatterns.com/uploads/mJx7P4KYcMgwebzpEjvD4H/Gemini_Generated_Image_sr7nlesr7nlesr7n.png'

export const previewImage =
  'https://cdn.magicpatterns.com/uploads/u4isp2dNXdkTHUqtwNebq5/Gemini_Generated_Image_jqcjhpjqcjhpjqcj.png'
